import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {flatMap} from 'lodash-es';

export function getLongestProductionSchedulePath(productionSchedulePathsOfColoredYarnSets: ProductionSchedulePathsOfColoredYarnSet[]): number {
  const pathGroups = flatMap(
    productionSchedulePathsOfColoredYarnSets,
    (productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet) => productionSchedulePathsOfColoredYarnSet.productionSchedulePaths
  );
  return pathGroups.length > 0 ? Math.max(...pathGroups.map((pathGroup: ProductionSchedulePath) => pathGroup.totalLengthInPicks)) : 0;
}
